import { createFileRoute } from '@tanstack/react-router';
import SectionTitle from 'src/components/ui/SectionTitle';
import ContactForm from 'src/components/ContactForm';

const ContactPage = () => {
  return (
    <>
      <SectionTitle title="Contact" className="px-6 py-4" />
      <div className="bg-surface-alt rounded-3xl shadow-3 p-6">
        <ContactForm />
      </div>
    </>
  );
};

export const Route = createFileRoute(
  '/_authenticated/_layout-advanced/contact'
)({
  component: ContactPage,
});
